import { Defer } from './Defer';
/*
 * Gate to lock access to some resource.
 */
export class Gate {
    pending;
    constructor(isOpen) {
        if (!isOpen) {
            this.close();
        }
    }
    open() {
        this.clearPending();
    }
    close() {
        this.pending ??= new Defer();
    }
    isOpen() {
        return !this.pending;
    }
    clearPending() {
        const { pending } = this;
        if (pending === undefined) {
            return;
        }
        this.pending = undefined;
        pending.resolve(undefined);
    }
    async waitUntilOpen() {
        if (this.pending) {
            await this.pending;
        }
    }
}
